import { render, staticRenderFns } from "./g-select.vue?vue&type=template&id=153a5ebb&scoped=true"
import script from "./g-select.vue?vue&type=script&lang=js"
export * from "./g-select.vue?vue&type=script&lang=js"
import style0 from "./g-select.vue?vue&type=style&index=0&id=153a5ebb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153a5ebb",
  null
  
)

export default component.exports